import { ReactElement } from "react";

import MetaManager from "@/includes/components/MetaManager";

import { getArtistByIdAsync } from "../../../lib/artists-manager";
import { Artist } from "../../../models/models";
import SafeContainer from "../../../components/navigation/safe-container";
import CreatorsPageContent from "@/components/creators";
import { slugify } from "@/lib/helpers";

export async function getServerSideProps({
  params,
}: {
  params: { id: string };
}) {
  try {
    const { id } = params;
    const { artist } = await getArtistByIdAsync(id);

    return {
      props: {
        data: artist,
      },
    };
  } catch (error) {
    console.error("Error fetching artist:", error);
    return {
      notFound: true,
    };
  }
}

interface CreatorsPageProps {
  data: Artist;
}

const CreatorsPage = ({ data }: CreatorsPageProps) => {
  return (
    <>
      <MetaManager
        title={data.name}
        description={data.bio?.length > 150 ? data.bio?.slice(0, 150) + "..." : data.bio}
        image={data.profilePicUrl}
        url={`https://lutely.com/creators/${slugify(data.name)}/${data.id}`}
        links={[{
          rel: 'canonical',
          href: `https://lutely.com/creators/${slugify(data.name)}/${data.id}`,
          key: 'canonical'
        }]}
      />
      <SafeContainer
        footer
        navbar
        className="bg-background pb-4 px-4 lg:px-16 xl:px-section overflow-y-auto md:pt-[128px]"
      >
        <CreatorsPageContent data={data} />
      </SafeContainer>
    </>
  );
};

CreatorsPage.getLayout = (page: ReactElement) => {
  return <>{page}</>;
};

export default CreatorsPage;
